const config = {
  baseUrl: process.env.REACT_APP_API_URL,
  videoCDN: process.env.REACT_APP_VIDEO_CDN,
};

export default config;
